import React, { useEffect, useState } from 'react';
import { Button, Divider, Form, Input, Modal, Select, Switch } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import { useForm } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
const service = new StoreSettingService();

const PrintSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [editingTemplateKey, setEditingTemplateKey] = useState(null);
    const [defaultPrintSetting, setDefaultPrintSetting] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewHtml, setPreviewHtml] = useState("");
    const paperSizeOptions = ["A4", "A5", "A6", "Letter", "Legal"].map(x => ({ label: x, value: x }));
    const templateItems = [
        {
            key: "invoice",
            label: "Mẫu hóa đơn",
            paperField: ["templates", "invoice", "paper_size"],
            customField: ["templates", "invoice", "is_custom"],
            htmlField: ["templates", "invoice", "template_html"],
        },
        {
            key: "packing",
            label: "Mẫu phiếu đóng gói",
            paperField: ["templates", "packing_list", "paper_size"],
            customField: ["templates", "packing_list", "is_custom"],
            htmlField: ["templates", "packing_list", "template_html"],
        },
        {
            key: "shipping",
            label: "Mẫu nhãn vận chuyển",
            paperField: ["templates", "shipping_label", "paper_size"],
            customField: ["templates", "shipping_label", "is_custom"],
            htmlField: ["templates", "shipping_label", "template_html"],
            shippingFields: [
                { name: ["templates", "shipping_label", "description"], label: "Mô tả" },
                { name: ["templates", "shipping_label", "sender_name"], label: "Người gửi" },
                { name: ["templates", "shipping_label", "sender_phone"], label: "Số điện thoại người gửi" },
            ]
        }
    ];
    const editingTemplate = templateItems.find(x => x.key === editingTemplateKey);
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        var setting = await service.getPrintSetting();
        form.setFieldsValue(setting);
    }

    const getDefaultSetting = async () => {
        if (defaultPrintSetting) {
            return defaultPrintSetting;
        }
        const data = await service.getDefaultPrintSetting();
        setDefaultPrintSetting(data);
        return data;
    }

    const onRestoreDefaultTemplate = async () => {
        if (!editingTemplate) {
            return;
        }

        showLoading(true);
        try {
            const defaults = await getDefaultSetting();
            const templateKey = editingTemplate.key === "packing" ? "packing_list" : editingTemplate.key === "shipping" ? "shipping_label" : "invoice";
            const defaultTemplate = defaults?.templates?.[templateKey] || {};

            form.setFieldValue(["templates", templateKey, "template_html"], defaultTemplate?.template_html || "");
            showNotify("Đã khôi phục mẫu mặc định")
        } finally {
            showLoading(false);
        }
    }

    const onPreviewTemplate = () => {
        if (!editingTemplate?.htmlField) return;
        const html = form.getFieldValue(editingTemplate.htmlField) || "";
        setPreviewHtml(html);
        setPreviewOpen(true);
    };

    const onToggleCustom = async (checked) => {
        if (!editingTemplate) {
            return;
        }

        const templateKey = editingTemplate.key === "packing" ? "packing_list" : editingTemplate.key === "shipping" ? "shipping_label" : "invoice";
        const htmlFieldPath = ["templates", templateKey, "template_html"];
        const currentHtml = form.getFieldValue(htmlFieldPath);

        if (checked && !currentHtml) {
            const defaults = await getDefaultSetting();
            const defaultHtml = defaults?.templates?.[templateKey]?.template_html || "";
            form.setFieldValue(htmlFieldPath, defaultHtml);
        }
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        await service.savePrintSetting(values)
        await loadData();
        showLoading(false);
        setEditingTemplateKey(null);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (


        <Form
            form={form}
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >

            <Divider>Thông tin chung</Divider>
            <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[{ required: true, message: 'Please input your website!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Hình ảnh"
                name="image"
                rules={[]}
            >
                <ImagePicker ></ImagePicker>
            </Form.Item>

            <Form.Item
                label="Ghi chú"
                name={"note"}
                rules={[]}
            >
                <Input />
            </Form.Item>

            <Divider>Mẫu in</Divider>
            {templateItems.map(item => (
                <Form.Item key={item.key} label={item.label}>
                    <Button onClick={() => setEditingTemplateKey(item.key)}>Chỉnh sửa</Button>
                </Form.Item>
            ))}

            <Modal
                open={!!editingTemplate}
                onCancel={() => setEditingTemplateKey(null)}
                width={1000}
                title={editingTemplate?.label || "Chỉnh sửa mẫu in"}
                footer={[
                    <Button key="restore" onClick={onRestoreDefaultTemplate}>
                        Khôi phục mặc định
                    </Button>,
                    <Button key="cancel" onClick={() => setEditingTemplateKey(null)}>
                        Đóng
                    </Button>,
                    <Button key="save" type="primary" onClick={() => form.submit()}>
                        Lưu
                    </Button>
                ]}
            >
                {editingTemplate?.paperField && (
                    <Form.Item label="Khổ giấy" name={editingTemplate.paperField}>
                        <Select options={paperSizeOptions} />
                    </Form.Item>
                )}
                {editingTemplate?.customField && (
                    <Form.Item label="Dùng mẫu custom" name={editingTemplate.customField} valuePropName="checked">
                        <Switch onChange={onToggleCustom} />
                    </Form.Item>
                )}
                {editingTemplate?.shippingFields?.map(field => (
                    <Form.Item key={field.name.join(".")} label={field.label} name={field.name}>
                        <Input />
                    </Form.Item>
                ))}
                {editingTemplate?.htmlField && (
                    <Form.Item shouldUpdate noStyle>
                        {() => {
                            const isCustom = form.getFieldValue(editingTemplate.customField);
                            if (!isCustom) {
                                return null;
                            }
                            return (
                                <>
                                    <Form.Item label="Mẫu HTML" name={editingTemplate.htmlField}>
                                        <Input.TextArea rows={5} />
                                    </Form.Item>
                                    <Form.Item label={null}>
                                        <Button onClick={onPreviewTemplate}>Xem trước</Button>
                                    </Form.Item>
                                </>
                            )
                        }}
                    </Form.Item>
                )}
            </Modal>

            <Modal
                open={previewOpen}
                onCancel={() => setPreviewOpen(false)}
                title="Xem trước mẫu in"
                width={1000}
                footer={[
                    <Button key="close-preview" onClick={() => setPreviewOpen(false)}>Đóng</Button>
                ]}
            >
                <iframe
                    title="print-template-preview"
                    style={{ width: "100%", height: 500, border: "1px solid #d9d9d9", background: "#fff" }}
                    srcDoc={previewHtml}
                />
            </Modal>

            <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                    Cập nhật
                </Button>
            </Form.Item>
        </Form>
    )
}
export default PrintSetting;
